import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { POItemUnitEnum } from '../../globals-enums/po.unit.enum';
import { OrderStatusEnum } from '../../globals-enums/order.status.enum';
import { PurchaseOrderService } from '../../globals-services/purchase-order.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'app/common/toast-alert/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-update-po-item-delivery-dialog',
    templateUrl: './update-po-item-delivery-dialog.component.html',
    styleUrls: ['./update-po-item-delivery-dialog.component.css'],
})
export class UpdatePoItemDeliveryDialogComponent implements OnInit {
    poItem: any;
    deliveryForm: FormGroup;
    remainingQuantity: any;
    batchList: any = [];
    po: any;
    //showSuccessMessage: boolean = false;
    // showErrorMessage: boolean = false;
    isLoading: boolean;
    pOUnitEnum = POItemUnitEnum;
    alertMsgs = {};

    constructor(
        public dialogRef: MatDialogRef<UpdatePoItemDeliveryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        private fb: FormBuilder,
        private purchaseOrderService: PurchaseOrderService,
        private translateService: TranslateService,
        private toastService: ToastService
    ) {}

    ngOnInit() {
        this.fetchTranslations();
        this.translateService.onLangChange.subscribe(() => {
            this.fetchTranslations();
        });

        this.po = this.data.po;
        this.poItem = this.data.poItem;
        // console.info(this.poItem)
        // console.info(this.po)
        this.remainingQuantity =
            this.poItem.quantity - this.poItem.receivedQuantity;
        this.getBatchDetails();
        this.initPOForm();
        // this.deliveryForm.patchValue(this.poItem)
    }

    fetchTranslations() {
        this.translateService
            .get('PURCHASE_ORDER_MODULE.UPDATE_DELIVERY_DIALOG.MESSAGES')
            .subscribe((response) => {
                this.alertMsgs = response;
                // console.log(this.alertMsgs);
            });
    }

    initPOForm() {
        this.deliveryForm = this.fb.group({
            status: ['', Validators.nullValidator],
            purchaseOrderChemicalId: [this.po.id, Validators.nullValidator],
            id: [this.poItem.id, Validators.nullValidator],
            poItemDeliveryDtos: this.fb.array([this.initItemDeliveryForm()]),
        });
    }
    get getPoItemControl() {
        return this.deliveryForm.get('poItemDeliveryDtos') as FormArray;
    }

    initItemDeliveryForm() {
        return this.fb.group({
            id: ['', Validators.nullValidator],
            receivedQuantity: [, Validators.required],
            batchNumber: ['', Validators.required],

            manufactureDate: ['', Validators.nullValidator],
            expiryDate: ['', Validators.nullValidator],
        });
    }
    addItem() {
        const ctrl = this.deliveryForm.get('poItemDeliveryDtos') as FormArray;
        ctrl.push(this.initItemDeliveryForm());
    }

    deleteItem(index) {
        const ctrl = this.deliveryForm.get('poItemDeliveryDtos') as FormArray;
        ctrl.removeAt(index);
    }
    getBatchDetails() {
        let data = {
            id: this.poItem.id,
        };
        this.purchaseOrderService.fetchBatchDetails(data).subscribe(
            (response: any) => {
                this.batchList = response;
            },
            (error) => {}
        );
    }
    saveDelivery(formValue) {
        console.info(formValue);
        let deliveryQuant = 0;
        formValue.poItemDeliveryDtos.forEach((element) => {
            deliveryQuant += element.receivedQuantity;
        });
        if (deliveryQuant >= this.remainingQuantity) {
            formValue.status = OrderStatusEnum.COMPLETED;
        } else {
            formValue.status = OrderStatusEnum.PARTIALLY_COMPLETED;
        }
        console.info(formValue);
        this.purchaseOrderService.savePoItemDelivery(formValue).subscribe(
            (response: any) => {
                this.isLoading = false;
                this.dialogRef.close(true);
                this.toastService.success(
                    this.alertMsgs['DELIVERY_SAVE_SUCCESS']
                );

                // this.showSuccessMessage = true
                // this.isLoading = true;
                // setTimeout(
                //   () => {
                //     this.showSuccessMessage = false;
                //     this.isLoading = false;
                //     this.dialogRef.close(true)

                //   }, 2000
                // );
            },
            (error) => {
                // if (error['status'] == '404' || error['status'] == '500' || error['status'] == '400') {
                //   alert("The action could not be completed. Please try again later.If the problem persists please contact Bhive team.")

                // }
                this.toastService.error(this.alertMsgs['DELIVERY_SAVE_ERROR']);

                // setTimeout(
                //   () => {
                //     this.showErrorMessage = false;
                //     this.isLoading = false;
                //   }, 2000
                // );
            }
        );
    }
    checkIfBatchPresent(event, poItemDeliveryDtos) {
        let batchNumber = event.target.value;
        let isBatchPresent = this.batchList.find(
            (x) => x.batchNumber == batchNumber
        );
        console.info(isBatchPresent);
        if (isBatchPresent) {
            poItemDeliveryDtos.patchValue({
                batchNumber: isBatchPresent.batchNumber,
                manufactureDate: isBatchPresent.manufactureDate,
                expiryDate: isBatchPresent.expiryDate,
            });
        }
    }

    close() {
        this.dialogRef.close(null);
    }
}
